import { clubApi } from "./axios";

export interface OwnerSelection { customerIds: number[]; merchantUserIds: number[] }
export interface AssignmentResult { assignedCount: number; alreadyAssignedCount: number; customerCount: number; merchantUserCount: number }
export const assignOwners = async (data: OwnerSelection) =>
  (await clubApi.instance.post<AssignmentResult>("/api/Customer/AssignOwners", data)).data;
export const unassignOwners = async (data: OwnerSelection) =>
  (await clubApi.instance.post<{ removedCount: number }>("/api/Customer/UnassignOwners", data)).data;
export const orderCategories = async (ids: number[]) =>
  clubApi.instance.put("/api/MerchantServiceCategory/Order", { ids });
export const orderServices = async (serviceCategoryId: number, ids: number[]) =>
  clubApi.instance.put("/api/MerchantService/Order", { serviceCategoryId, ids });
